import React, { useEffect, useState } from "react";

import Popup from "components/commonComponents/popup/Popup"

import "../../intro/IntroBody/body.scss"
import { Tabs, Tab } from "@mui/material";
import About from "components/intro/IntroBody/About";
import Introduction from "components/intro/IntroBody/Introduction";
import Objective from "components/intro/IntroBody/Objective";
import TabSwitcher from "components/intro/IntroBody/TabSwitcher";
import { getString } from "utils";

interface IObjectives {
    close: () => void
}

const Objectives: React.FC<IObjectives> = (props: IObjectives) => {
    const [showComponent, setShowComponent] = useState(true)
    const [currentTab, setValue] = React.useState(0);
    // const  audio = new Audio("/popup.mp3")

    // useEffect(()=>{
	// 	audio.play()
	// },[])
    
    const handleClose = () => {
        setShowComponent(false)
        props.close()
    }
    const handleChange = (event: React.ChangeEvent<{}>, newValue: number) => {
        setValue(newValue);
    }

    const handleTabChange = (newValue: number) => {
        setValue(newValue)
    }


    return (
        <>
            {showComponent ?
                <Popup handleClose={handleClose}>
                    <div className="phead">
                        <div style={{ display: "contents" }}>
                            <div className="metric-popup-icon">
                                <img src={require(`assets/images/objectives.svg`).default} style={{ width: "2vw" }} />
                            </div>
                            <span>&nbsp;{getString("label_base_objectives")}</span>
                        </div>
                    </div>
                    <div className="curved-header"></div>
                    <div className="pbody" style={{ marginRight: "0", paddingTop: "3vh" }}>
                        <Tabs
                            value={currentTab}
                            classes={{ indicator: "indicator" }}
                            onChange={handleChange}
                            indicatorColor="primary"
                            textColor="primary"
                            centered
                        >
                            <Tab label={getString("label_intro_introduction")} className="tabHead" disableRipple classes={{ textColorPrimary: "textColorPrimary" }} />
                            <Tab label={getString("label_intro_abt_comm")} className="tabHead" disableRipple classes={{ textColorPrimary: "textColorPrimary" }} />
                            <Tab label={getString("label_base_objectives")} className="tabHead" disableRipple classes={{ textColorPrimary: "textColorPrimary" }} />
                        </Tabs>

                        <TabSwitcher value={currentTab} index={0}>
                            <Introduction onTabChange={handleTabChange} isPopup={true} />
                        </TabSwitcher>
                        <TabSwitcher value={currentTab} index={1}>
                            <About onTabChange={handleTabChange} isPopup={true} />
                        </TabSwitcher>
                        <TabSwitcher value={currentTab} index={2}>
                            <Objective onTabChange={handleTabChange} isPopup={true} />
                        </TabSwitcher>
                    </div>
                </Popup>
                : null}
        </>
    )
};

export default Objectives;
